import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "relative w-full min-h-svh flex flex-col justify-center bg-white py-16 dark:bg-neutral-900" }
const _hoisted_2 = { class: "absolute inset-0 overflow-hidden pointer-events-none" }
const _hoisted_3 = { class: "relative z-10 max-w-(--ui-container) mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_4 = { class: "text-center mb-16 space-y-4" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 relative" }
const _hoisted_6 = { class: "flex flex-col h-full" }
const _hoisted_7 = { class: "h-48 sm:h-52 flex items-center justify-center mb-6 rounded-2xl overflow-hidden relative" }
const _hoisted_8 = { class: "text-center space-y-3" }
const _hoisted_9 = { class: "flex justify-center" }
const _hoisted_10 = { class: "relative inline-flex h-10 w-10 items-center justify-center rounded-full bg-purple-100 text-purple-600 dark:bg-purple-900/50 dark:text-purple-300 font-bold text-lg transition-all duration-500 group-hover:scale-125 group-hover:rotate-12 group-hover:shadow-md" }
const _hoisted_11 = { class: "font-bold text-lg sm:text-xl text-gray-900 dark:text-white transition-colors duration-300 group-hover:text-purple-600 dark:group-hover:text-purple-400" }
const _hoisted_12 = { class: "text-sm sm:text-base text-gray-600 dark:text-gray-400 leading-relaxed" }

import { ref } from "vue";
import { Motion } from "motion-v";


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkSteps',
  setup(__props) {

const hoveredStates = ref({
  1: false,
  2: false,
  3: false,
});

const steps = [
  {
    step: 1,
    title: "Create and Activate a Resident",
    description:
      "Get started by adding a new resident to the system. Activate their profile to begin tracking their progress and engagement.",
    link: "/learn-more/step-1",
  },
  {
    step: 2,
    title: "Log Observations, Tasks and Direct Work Sessions",
    description:
      "Easily record observations, tasks and direct work sessions. Use our customisable templates to ensure all important details are captured.",
    link: "/learn-more/step-2",
  },
  {
    step: 3,
    title: "Analyse and Export Reports",
    description:
      "Turn your data into actionable insights. Analyse trends, track outcomes, and export comprehensive, court-ready reports.",
    link: "/learn-more/step-3",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_LazyStepOneAnimation = _resolveComponent("LazyStepOneAnimation")!
  const _component_LazyStepTwoAnimation = _resolveComponent("LazyStepTwoAnimation")!
  const _component_LazyStepThreeAnimation = _resolveComponent("LazyStepThreeAnimation")!
  const _component_UCard = _resolveComponent("UCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Motion), {
        initial: { x: -400, opacity: 0, scale: 0.5, rotate: -45 },
        "while-in-view": { x: 0, opacity: 1, scale: 1, rotate: 0 },
        viewport: { once: true },
        transition: { duration: 1.2, ease: [0.22, 1, 0.36, 1] },
        class: "absolute top-20 -left-20 w-96 h-96 bg-gradient-to-br from-purple-200/30 to-pink-200/30 dark:from-purple-500/10 dark:to-pink-500/10 rounded-full blur-3xl"
      }),
      _createVNode(_unref(Motion), {
        initial: { x: 400, opacity: 0, scale: 0.5, rotate: 45 },
        "while-in-view": { x: 0, opacity: 1, scale: 1, rotate: 0 },
        viewport: { once: true },
        transition: { duration: 1.2, ease: [0.22, 1, 0.36, 1], delay: 0.2 },
        class: "absolute -bottom-20 -right-20 w-[500px] h-[500px] bg-gradient-to-tl from-indigo-200/25 to-purple-200/25 dark:from-indigo-500/8 dark:to-purple-500/8 rounded-full blur-3xl"
      }),
      _createVNode(_unref(Motion), {
        initial: { y: 100, opacity: 0 },
        "while-in-view": { y: 0, opacity: 1 },
        viewport: { once: true },
        transition: { duration: 1.5, ease: 'easeOut', delay: 0.4 },
        class: "absolute top-40 right-1/4 w-32 h-32 bg-gradient-to-br from-pink-200/20 to-purple-200/20 dark:from-pink-400/10 dark:to-purple-400/10 rounded-full blur-2xl animate-float-gentle"
      }),
      _createVNode(_unref(Motion), {
        initial: { y: -100, opacity: 0 },
        "while-in-view": { y: 0, opacity: 1 },
        viewport: { once: true },
        transition: { duration: 1.5, ease: 'easeOut', delay: 0.6 },
        class: "absolute bottom-40 left-1/4 w-40 h-40 bg-gradient-to-br from-indigo-200/20 to-purple-200/20 dark:from-indigo-400/10 dark:to-purple-400/10 rounded-full blur-2xl animate-float-delayed"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Motion), {
          initial: { opacity: 0, scale: 0.8, y: 30 },
          "while-in-view": { opacity: 1, scale: 1, y: 0 },
          viewport: { once: true },
          transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] }
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("h2", { class: "text-3xl sm:text-4xl lg:text-5xl font-bold text-purple-600 dark:text-purple-400" }, " HOW IT WORKS ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(Motion), {
          initial: { opacity: 0, y: 20 },
          "while-in-view": { opacity: 1, y: 0 },
          viewport: { once: true },
          transition: { duration: 0.7, ease: 'easeOut', delay: 0.2 }
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("p", { class: "text-base sm:text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" }, " Take a closer look at the features that make FamilyAxis a powerful tool for family assessment centres. ", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(Motion), {
          class: "hidden lg:block absolute inset-x-0 top-1/2 -translate-y-1/2 z-0 pointer-events-none",
          initial: { opacity: 0 },
          "while-in-view": { opacity: 1 },
          viewport: { once: true },
          transition: { duration: 0.5, delay: 0.8 }
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("svg", {
              class: "w-full max-w-5xl mx-auto h-1",
              viewBox: "0 0 1200 4",
              preserveAspectRatio: "none"
            }, [
              _createElementVNode("defs", null, [
                _createElementVNode("linearGradient", {
                  id: "lineGradient",
                  gradientUnits: "userSpaceOnUse",
                  x1: "0",
                  y1: "0",
                  x2: "1200",
                  y2: "0"
                }, [
                  _createElementVNode("stop", {
                    offset: "0%",
                    style: {"stop-color":"rgb(192, 132, 252)","stop-opacity":"0.3"}
                  }),
                  _createElementVNode("stop", {
                    offset: "50%",
                    style: {"stop-color":"rgb(244, 114, 182)","stop-opacity":"0.5"}
                  }),
                  _createElementVNode("stop", {
                    offset: "100%",
                    style: {"stop-color":"rgb(192, 132, 252)","stop-opacity":"0.3"}
                  })
                ])
              ]),
              _createElementVNode("line", {
                x1: "0",
                y1: "2",
                x2: "1200",
                y2: "2",
                stroke: "url(#lineGradient)",
                "stroke-width": "2",
                "stroke-dasharray": "1200",
                "stroke-dashoffset": "1200",
                class: "animate-draw-line"
              })
            ], -1)
          ]))]),
          _: 1
        }),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step) => {
          return _createVNode(_unref(Motion), {
            key: step.step,
            initial: { opacity: 0, y: 60, rotateY: -15, scale: 0.9 },
            "while-in-view": { opacity: 1, y: 0, rotateY: 0, scale: 1 },
            viewport: { once: true },
            transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: step.step * 0.15 },
            class: "group relative",
            onMouseenter: ($event: any) => (hoveredStates.value[step.step] = true),
            onMouseleave: ($event: any) => (hoveredStates.value[step.step] = false)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_UCard, {
                to: step.link,
                class: "relative block h-full opacity-90 hover:opacity-100 transition-all duration-500 hover:-translate-y-2 hover:rotate-1 z-10",
                ui: {
              background: 'bg-white dark:bg-slate-800',
              ring: 'ring-1 ring-gray-200 dark:ring-slate-700',
              rounded: 'rounded-3xl',
              shadow: 'shadow-sm hover:shadow-xl',
              padding: 'p-6 sm:p-8',
            }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_unref(Motion), {
                        initial: { x: '-100%' },
                        "while-in-view": { x: '200%' },
                        viewport: { once: true },
                        transition: { duration: 1, ease: 'easeOut', delay: step.step * 0.15 + 0.5 },
                        class: "absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12"
                      }, null, 8, ["transition"]),
                      (step.step === 1)
                        ? (_openBlock(), _createBlock(_component_LazyStepOneAnimation, {
                            key: 0,
                            "is-hovering": hoveredStates.value[1]
                          }, null, 8, ["is-hovering"]))
                        : (step.step === 2)
                          ? (_openBlock(), _createBlock(_component_LazyStepTwoAnimation, {
                              key: 1,
                              "is-hovering": hoveredStates.value[2]
                            }, null, 8, ["is-hovering"]))
                          : (step.step === 3)
                            ? (_openBlock(), _createBlock(_component_LazyStepThreeAnimation, {
                                key: 2,
                                "is-hovering": hoveredStates.value[3]
                              }, null, 8, ["is-hovering"]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createTextVNode(_toDisplayString(step.step) + " ", 1),
                          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute inset-0 rounded-full bg-purple-400/30 scale-100 opacity-0 group-hover:scale-150 group-hover:opacity-100 transition-all duration-500" }, null, -1))
                        ])
                      ]),
                      _createElementVNode("h3", _hoisted_11, _toDisplayString(step.title), 1),
                      _createElementVNode("p", _hoisted_12, _toDisplayString(step.description), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"]),
              (step.step < 3)
                ? (_openBlock(), _createBlock(_unref(Motion), {
                    key: 0,
                    initial: { scale: 0, opacity: 0 },
                    "while-in-view": { scale: 1, opacity: 1 },
                    viewport: { once: true },
                    transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1], delay: step.step * 0.15 + 0.8 },
                    class: "hidden lg:block absolute -right-4 top-1/2 -translate-y-1/2 z-20"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("div", { class: "relative" }, [
                        _createElementVNode("div", { class: "w-3 h-3 rounded-full bg-gradient-to-r from-purple-400 to-pink-400 animate-pulse-slow" }),
                        _createElementVNode("div", { class: "absolute inset-0 w-3 h-3 rounded-full bg-purple-400 animate-ping" })
                      ], -1)
                    ]))]),
                    _: 1
                  }, 8, ["transition"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["transition", "onMouseenter", "onMouseleave"])
        }), 64))
      ])
    ])
  ]))
}
}

})